import createCachedSelector, { LruCacheObject } from 're-reselect';
import { REDUCER_KEY } from './reducer';

export const getFilterStore = (state) => state[REDUCER_KEY];
// eslint-disable-next-line
export const getLastSyncDate = (state: any) => getFilterStore(state).lastSyncDate;
export const getFilters = (state) => getFilterStore(state).resourcesById;

export const getFilter = createCachedSelector(
  (state, filterId) => filterId,
  (state) => getFilters(state),
  (filterId, filters) => {
    const filter = filters.find((f) => f.id === filterId);
    if (!filter) {
      return ({ type: '', items: [] });
    }
    switch(filter.filterItems[0].type) {
      case 'CHARTOFACCOUNT': {
        const categories = filter.filterItems[0].chartOfAccounts.map((item) => item.id);
        return ({
          type: 'categories',
          items: categories,
        });
      }
      case 'PAYEE': {
        const { payees } = filter.filterItems[0];
        return ({ type: 'payees', items: payees });
      }
      case 'TAG': {
        const { tags } = filter.filterItems[0];
        return ({ type: 'tags', items: tags });
      }
      default: break;
    }
    return ({ type: '', items: [] });
  }
)(
  // this line sets the key to use for the cache
  (state, filterId) => filterId,
  {
    cacheObject: new LruCacheObject({ cacheSize: 4 }),
  }
);;
